<template>
  <div class="teaMain">
    <div class="searchWrap">
      <div class="selectWrap">
        <template v-if="isFive">
          <select v-model="search.teacher_level_five" @change="changeQuery(true)">
            <option value="">全部讲师级别</option>
            <option
              v-for="(item, index) in filterData.teacher_level"
              :key="index"
              :value="item.value"
            >
              {{ item.key }}
            </option>
          </select>
        </template>
        <template v-else>
          <select v-model="search.teacher_level" @change="changeQuery(true)">
          <option value="">全部等级讲师级别</option>
          <option
            v-for="(item, index) in filterData.teacher_level"
            :key="index"
            :value="item.value"
          >
            {{ item.key }}
          </option>
        </select>
        <select v-model="search.teacher_level_g" @change="changeQuery(true)">
          <option value="">全部守门员讲师级别</option>
          <option
            v-for="(item, index) in filterData.teacher_goal_level"
            :key="index"
            :value="item.value"
          >
            {{ item.key }}
          </option>
        </select>
          <select v-model="search.teacher_level_physical" @change="changeQuery(true)">
            <option value="">全部体能讲师级别</option>
            <option
              v-for="(item, index) in filterData.teacher_physical_level"
              :key="index"
              :value="item.value"
            >
              {{ item.key }}
            </option>
          </select>
        </template>
      </div>
      <div class="search">
        <div class="wrap">
          <input
            type="text"
            placeholder="请输入搜索内容"
            v-model.lazy="search.name"
            @keyup.enter="searchResult"
          />
          <div v-show="search.name != ''" class="close" @click="hideIcon">
            <v-icon name="regular/times-circle" scale="1.2"></v-icon>
          </div>
        </div>
        <div class="searchBtn" @click="searchResult">搜索</div>
      </div>
    </div>
    <yioks-loading v-show="isLoading"></yioks-loading>
    <template v-if="!isLoading">
      <template v-if="showList">
        <div class="table">
          <div class="thead">
            <div class="tr">
              <div class="th index"><strong>序号</strong></div>
              <div class="th name"><strong>讲师姓名</strong></div>
              <div class="th level"><strong>讲师级别</strong></div>
              <div class="th level_g" v-if="!isFive">
                <strong>守门员讲师级别</strong>
              </div>
              <div class="th level_g" v-if="!isFive">
                <strong>体能讲师级别</strong>
              </div>
              <div class="th unit"><strong>注册协会</strong></div>
              <div class="th phone"><strong>联系电话</strong></div>
              <div class="th status"><strong>状态</strong></div>
              <div class="th opt"><strong>操作</strong></div>
            </div>
          </div>
          <div class="scrollArea">
            <vue-scroll :ops="ops" ref="vs">
              <div class="tbodyWrap">
                <div class="tbody">
                  <div class="tr" v-for="(item, index) in list" :key="index">
                    <div class="td index">
                      <p>{{ index+1 }}</p>
                    </div>
                    <div class="td name">
                      <p :title="item.name">{{ item.name }}</p>
                    </div>
                    <div class="td level">
                      <p>
                        {{
                          isFive
                            ? item.teacher_level_five
                            : item.teacher_level | teacherFilter(isFive)
                        }}
                      </p>
                    </div>
                    <div class="td level_g" v-if="!isFive">
                      <p :title="item.teacher_level_g | teacherFilter(isFive)">
                        {{ item.teacher_level_g | teacherFilter(isFive) }}
                      </p>
                    </div>
                    <div class="td level_g" v-if="!isFive">
                      <p :title="item.teacher_level_physical | teacherFilter(isFive)">
                        {{ item.teacher_level_physical | teacherFilter(isFive) }}
                      </p>
                    </div>
                    <div class="td unit">
                      <p>{{ item.work_unit || "--" }}</p>
                    </div>
                    <div class="td phone">
                      <p>{{ item.mobile_phone || "--" }}</p>
                    </div>
                    <div class="td status">
                      <p>{{ item.status | userStatus }}</p>
                    </div>
                    <div class="td opt">
                      <span @click="lookOver(item.user_id)">查看</span>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <div id="paging">
          <yioks-paging
            :paging="paging"
            @goto-page="gotoPage($event)"
          ></yioks-paging>
        </div>
      </template>
      <yioks-empty v-if="showEmpty"></yioks-empty>
    </template>
  </div>
</template>

<script>
import ops from "@/assets/js/vuescrollOption";
import { smTeacher } from "@/api/system_manager/api";
import fiveMixins from "@/minix/fiveMixins";
import { userStatus } from "@/assets/js/status";
import { teacher_level,teacher_level_goalkeeper,teacher_level_physical, teacher_level_five } from "@/assets/js/select";

export default {
  name: "eva-teacher",
  mixins: [fiveMixins],
  data() {
    return {
      ops: ops(),
      page: 1,
      paging: {
        start: 0, // 每页从第几条数据开始
        prePage: 1, // 一页多少条数据
        total: 1, // 总页数
        size: 3, // 页码显示限制
        last: true, // 尾页
        next: true, // 下一页
        first: true, // 首页
        previous: true, // 上一页
        jump: true,
      },
      list: [],
      search: {
        name: "",
        teacher_level: "",
        teacher_level_five: "",  // 暂时没有增加五人制
        teacher_level_g: "",
        teacher_level_physical: "",
      },
      isLoading: true,
      showList: false,
      showEmpty: false,
      filterData: {
        teacher_level: [],
        teacher_goal_level: teacher_level_goalkeeper,
        teacher_physical_level: teacher_level_physical,
      },
    };
  },
  components: {
    "yioks-paging": () => import("@/components/Pagination/Page"),
    "v-icon": () => import("vue-awesome/components/Icon"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
  },
  filters: {
    userStatus(status) {
      // switch (status) {
      //   case "Active":
      //     status = "正常";
      //     break;
      //   case "Abnormal":
      //     status = "暂停";
      //     break;
      //   case "Stop":
      //     status = "关闭";
      //     break;
      //   case "Deleted":
      //     status = "删除";
      //     break;
      //   default:
      //     status = "--";
      //     break;
      // }
      return userStatus(status);
    },
    tea_level(level) {
      return level == "E"
        ? "D级助理"
        : Number(level) == 0
        ? "职业级讲师"
        : `${level}级讲师`;
    },
  },
  created() {
    this.setData();
    this.request();
    if (this.isFive) {
      this.$set(this.filterData, "teacher_level", teacher_level_five);
    } else {
      this.$set(this.filterData, "teacher_level", teacher_level);
    }
  },
  methods: {
    setData() {
      // console.log(this.$route.query);
      const { page, name, teacher_level_g,teacher_level_physical, teacher_level,teacher_level_five } = this.$route.query;
      page && (this.page = page);
      name && this.$set(this.search, "name", name);
      teacher_level && this.$set(this.search, "teacher_level", teacher_level);
      teacher_level_g && this.$set(this.search, "teacher_level_g", teacher_level_g);
      teacher_level_physical && this.$set(this.search, "teacher_level_physical", teacher_level_physical);
      teacher_level_five && this.$set(this.search, "teacher_level_five", teacher_level_five);
    },
    request() {
      this.isLoading = true;
      smTeacher({ page: this.page, ...this.search })
        .then((res) => {
          this.isLoading = false;
          // console.log(res);
          const { result } = res.data;
          this.$set(this.paging, "prePage", result.page.page_size);
          this.$set(this.paging, "total", result.page.total_row);
          this.$set(
            this.paging,
            "start",
            (this.page - 1) * this.paging.prePage
          );
          this.list = result.list;
          this.showList = Boolean(result.list.length > 0);
          this.showEmpty = !this.showList;
        })
        .catch((err) => {
          this.isLoading = false;
          console.error(err);
        });
    },
    gotoPage(start) {
      this.page = parseInt(start / this.paging.prePage) + 1;
      this.changeQuery(false);
      this.$refs["vs"].scrollTo({ y: 0 });
    },
    changeQuery(flag) {
      flag && (this.page = 1);
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page: this.page,
          ...this.search,
        },
      });
      this.request();
    },
    lookOver(id) {
      this.$router.push({ path: "../eva_tea_detail", query: { id: id } });
    },
    hideIcon() {
      this.$set(this.search, "name", "");
      this.searchResult();
    },
    searchResult() {
      this.changeQuery(true);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
.teaMain
  width 100%
  height 100%
  padding 25px 0 0
  .searchWrap
    display flex
    justify-content space-between
    align-items center
    height 40px
    margin 0 40px
    user-select none
    .selectWrap
      width 600px
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      select {
        width: 155px;
        height: 100%;
        padding: 0 15px;
        font-size: $font_size_medium;
        color: $color_black;
        outline: none;
      }
    .search
      width 390px
      height 100%
      display flex
      justify-content flex-end
      align-items center
      .wrap
        height 100%
        position relative
        input
          width 170px
          height 100%
          padding 0 20px
          font-size $font_size_medium
          color $color_black
          outline none
        .close
          position absolute
          right 5px
          top 10px
          color $color_info
          cursor pointer
      .searchBtn
        width 90px
        height 100%
        display flex
        justify-content center
        align-items center
        color $color_white
        font-size 20px
        background-color $color_suc
        cursor pointer
  .table
    width 100%
    margin 30px 0 0
    color $color_white
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        height 45px
        display flex
    .scrollArea
      width 100%
      height 401px
    .tbodyWrap
      display block
      // padding: 0 40px;
    .tbody
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width 810px
      border-top none
      border-bottom none
      .tr
        height 49px
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      height 100%
      flex 1 1 auto
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td:last-child
      color $color_suc
      user-select none
    .td
      p
        over_hide()
    .index
      width 6%
    .name
      width 15%
    .level
      width 10%
    .unit
      width 11%
    .level_g
      width 15%
    .phone
      width 13%
    .status
      width 8%
    .opt
      width 7%
      span
        cursor pointer
  #paging
    width 100%
    height 77px
</style>
